export enum DOCUMENT_TYPES {
  passport = 'PASSPORT',
  id = 'ID_DOCUMENT',
  letter = 'LETTER_OF_ACCEPTANCE',
}
